import { TObject } from 'utils/types';

import { TRANSACTIONS_STATE } from '../transactions/constants';

import {
  IBulkCreateResultCodesResult,
  IBulkUpdateResultCodesResult,
  IResultCode,
  IResultCodeStates,
} from './types';

export const normalizeResultCode = (data: TObject): IResultCode => {
  return {
    adapter: (data?.adapter as string) || null,
    adapterResultCodePattern: (data?.adapterResultCodePattern as string) || null,
    bankParamValue: (data?.bankParamValue as string) || null,
    id: (data?.id as number) || null,
    internalTransactionState:
      (data?.internalTransactionState as TRANSACTIONS_STATE) || null,
    operationType: (data?.operationType as string) || null,
    paymentMethod: (data?.paymentMethod as string) || null,
    priority: (data?.priority as number) || null,
    resultCode: (data?.resultCode as string) || null,
    transactionType: (data?.transactionType as string) || null,
    userPspMessage: (data?.userPspMessage as string) || null,
  };
};

export const normalizeResultCodesStates = (data: TObject): IResultCodeStates => {
  return {
    transactionStates: (data?.transactionStates as string[]) || [],
  };
};

export const normalizeBulkCreateResultCodes = (
  data: TObject,
): IBulkCreateResultCodesResult => {
  return {
    createdIds: (data?.createdIds as number[]) || [],
  };
};

export const normalizeBulkUpdateResultCodes = (
  data: TObject,
): IBulkUpdateResultCodesResult => {
  return {
    updatedCount: (data?.updatedCount as number) || 0,
  };
};
